import {
  CLEAR_GLOBAL_PAYMENTS,
  LOAD_GLOBAL_PAYMENTS,
  SAVE_GLOBAL_PAYMENTS_OPTIONS
} from '../actions/globalPaymentActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  },
  items: [],
  count: 0,
  collectedInRange: 0
};

const globalPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_GLOBAL_PAYMENTS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count,
        collectedInRange: action.collectedInRange
      };
    }
    case SAVE_GLOBAL_PAYMENTS_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_GLOBAL_PAYMENTS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default globalPaymentReducer;
